import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import { installationsSearchSchema } from '@/ui/pages/Installations/installationsModel';
import InstallationsPage from '@/ui/pages/Installations/InstallationsPage';

/**
 * HS-1631: the installations list, a `@smartsash/data-screen` definition answered by the mock
 * transport until HS-1620 lands (`src/tmp/`).
 *
 * As `reports.index.tsx`, the route names only the search schema and loads the definition inside
 * its loader: `validateSearch`/`loaderDeps`/`loader` are not code-split, so naming the definition
 * here would put the screen — and the mock transport — in the entry chunk. The list searches on the
 * server and does not sort, so the deps are the search itself, as the definition's `loaderDeps`.
 */
export const Route = createFileRoute('/_dashboard/installations/')({
  validateSearch: (input: Record<string, unknown>) => installationsSearchSchema.parse(input),
  loaderDeps: ({ search }) => search,
  beforeLoad: requireRoute('/installations'),
  loader: async ({ context, deps }) => {
    const { installationsScreen } = await import('@/ui/pages/Installations/installationsScreen');
    return installationsScreen.loaderFor()({ context, deps });
  },
  component: InstallationsPage,
});
